import * as React from "react";
import Modal from 'react-bootstrap/Modal';

interface onSubmitFunction {
  (event : React.MouseEvent, reactRouteOnSuccess?) : void;
}

export interface PopupOKProps {
  formFieldDefinition: any;
  onOK : onSubmitFunction;
}

export const PopupOK = (props: PopupOKProps) => <Modal className="form__popup" centered show={true} onHide={() => {}}>
        <Modal.Header className="form__popup-header">
          <Modal.Title>{props.formFieldDefinition.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="form__popup-content">
          <div className="form__popup-content-text">{props.formFieldDefinition.explanation !== undefined && props.formFieldDefinition.text !== "" ? props.formFieldDefinition.text : null}</div>
          <div className="form__popup-content-explanation">{props.formFieldDefinition.explanation !== undefined && props.formFieldDefinition.explanation !== "" ? props.formFieldDefinition.explanation : null}</div>
        </Modal.Body>
        <Modal.Footer className="form__popup-buttons">
          <a href="#" onClick={e => props.onOK(e)} className="btn btn-primary">OK</a>
        </Modal.Footer>
      </Modal>;

